import React, { FC, useEffect } from 'react';

import { Box, Grid, Typography } from '@mui/material';

import {
  PharmacyLegendVariant,
  longTermBookingList,
  pharmacistActions,
  pharmacyActions,
  professionalBookingsList,
} from '@pharmaplan/common';

import { nameTypes } from '../Workshifts/WorkshiftForm/ViewEditContract/ViewEditContractTime/ViewEditContractTime';
import DateBox from '../Workshifts/WorkshiftForm/ViewEditContract/ViewEditContractTime/DateBox';
import useLongTermFormikDetails from '../../../hooks/LongTermContract/useLongTermFormikDetails';
import useProfessional from '../../../hooks/Professional/useProfessional';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import { useAppSelector } from '../../../hooks/useAppSelector';
import { resetDialog } from '../../../reducers/dialogReducer';
import { getDayMonthDateYear } from '../../Reports/helpers';
import LongContractCard from '../../common/LongContractCard';
import LongTermModalLayout from '../../common/LongTermModalLayout';
import CustomChip from '../../common/CustomChip';
import strings from '../../../localization';

import styles from './styles';

const { start, end } = nameTypes;

interface IViewLongTermBookings {
  getEvent: () => void;
}

const ViewLongTermBookings: FC<IViewLongTermBookings> = ({ getEvent }) => {
  const dispatch = useAppDispatch();
  const { isProfessional } = useProfessional();

  const professionalBookingList = useAppSelector(professionalBookingsList);
  const bookingList = useAppSelector(longTermBookingList);

  const event = isProfessional ? { ...professionalBookingList, pharmacyName: professionalBookingList?.name ?? '' } : bookingList;
  const { bookings, longTermShiftContract } = event ?? {};

  const { formik } = useLongTermFormikDetails(bookings, longTermShiftContract);

  const handleClose = () => {
    dispatch(resetDialog());
  };

  useEffect(() => {
    getEvent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LongTermModalLayout
      primary={{ label: strings.close, onPress: handleClose }}
    >
      <Grid md={5} xs={12} item>
        <LongContractCard
          successAction={
            isProfessional
              ? pharmacistActions.getPharmacistEvent
              : pharmacyActions.getLongTermBookingsById
          }
          event={event}
          isBooked
          formik={formik}
        />
      </Grid>
      <Grid md={7} xs={12} item>
        <Box>
          <Box sx={styles.titleContainer}>
            <Typography sx={styles.selectRequestText}>
              {strings.formatString(
                strings.allBookingsWithFormat,
                isProfessional
                  ? strings.pharmacy.toLowerCase()
                  : strings.professional.toLowerCase(),
              )}
            </Typography>
          </Box>
          <Box sx={styles.dateBoxGrid}>
            {bookings?.map?.((interval) => {
              const { startDate } = interval ?? {};
              const date = startDate?.split?.('T')?.[0];

              return (
                <DateBox
                  Chip={(
                    <CustomChip
                      type={PharmacyLegendVariant.booked}
                      label={strings.booked}
                    />
                  )}
                  key={date}
                  showCheckbox={false}
                  changedName={`${date}|${nameTypes.changed}`}
                  title={`${getDayMonthDateYear(date)}`}
                  startName={`${date}|${start}`}
                  endName={`${date}|${end}`}
                  formik={formik}
                  hideDayOff
                  disabled
                  dayOffName=""
                />
              );
            })}
          </Box>
        </Box>
      </Grid>
    </LongTermModalLayout>
  );
};

export default ViewLongTermBookings;
